import message from '@/basic/message/index';
let publics = {
    API_URL: API_URL,
    HOST: HOST,
    honorList: [
        { honor: 0, title: '普通印章', point: 0 },
        { honor: 1, title: '铁印章', point: 3000 },
        { honor: 2, title: '铜印章', point: 5000 },
        { honor: 3, title: '银印章', point: 8000 },
        { honor: 4, title: '金印章', point: 10000 }
    ],
    setCookie(name, value, days) {
        var d = new Date;
        d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
        window.document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
    },
    getCookie(name) {
        var v = window.document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
        return v ? v[2] : null;
    },
    deleteCookie(name) {
        this.setCookie(name, '', -1);
    },
    message: message,
    pageSize: 10,
}

export default publics


// WEBPACK FOOTER //
// ./src/basic/publics.js